export const YOUTUBE_VIDEO_ID = 'nmf-H8RLxR0';